const CalendarLegend = () => {
    const legendItems = [
        {
            color: '#28a745',
            borderColor: '#1e7e34',
            textColor: 'white',
            label: 'Confirmată',
            status: 'confirmed'
        },
        {
            color: '#ffc107',
            borderColor: '#d39e00',
            textColor: '#212529',
            label: 'În așteptare',
            status: 'pending'
        },
        {
            color: '#dc3545',
            borderColor: '#bd2130',
            textColor: 'white',
            label: 'Anulată',
            status: 'cancelled'
        },
        {
            color: '#f90f7e',
            borderColor: '#ad1457',
            textColor: 'white',
            label: 'Anulată de client',
            status: 'cancelled-client'
        }
    ];

    return (
        <div style={{ 
            marginBottom: '16px', 
            padding: '12px', 
            backgroundColor: '#f5f5f5', 
            borderRadius: '6px',
            border: '1px solid #d9d9d9',
            flexDirection:'row',
            display:'flex',
            alignItems:'center'
        }}>
            <div style={{ 
                fontSize: '14px', 
                fontWeight: '600', 
                color: '#595959',
                marginRight:'10px'
            }}>
                Legendă status rezervări:
            </div>
            <div style={{ 
                display: 'flex', 
                flexWrap: 'wrap', 
                gap: '12px' 
            }}>
                {legendItems.map((item, index) => (
                    <div key={index} style={{ 
                        display: 'flex', 
                        alignItems: 'center', 
                        gap: '6px' 
                    }}>
                        <div style={{
                            width: '16px',
                            height: '16px',
                            backgroundColor: item.color,
                            border: `1px solid ${item.borderColor}`,
                            borderRadius: '3px',
                            display: 'inline-block'
                        }} />
                        <span style={{ 
                            fontSize: '13px',
                            color: '#595959'
                        }}>
                            {item.label}
                        </span>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default CalendarLegend;